import {post} from '@/utils/request';
import {erpserver,oaserver,erpplatserver} from '@/utils/baseUrl';
//公司
export async function getCompanyList(params) {
    return post(oaserver+'/oacurrency/getCompanyList', params, true);
}
//结帐save
export async function monthCarry(params) {
    return post(erpserver+'/carry/monthCarry', params, true);
}
//反结帐save
export async function monthCarryUnDo(params) {
    return post(erpserver+'/carry/monthCarryUnDo', params, true);
}
//结帐list
export async function list(params) {
    return post(erpserver+'/carry/carryList', params, true);
}
//研发产品的列表
export async function getList(params) {
    return post(erpserver+'/research-product/getList', params, true);
}
//成本明细列表
export async function getExpenseDetailList(params) {
    return post(erpserver+'/research-product/getExpenseDetailList', params, true);
}
//成本金额进行支出转成本操作
export async function ExpenseToCostBatch(params) {
    return post(erpserver+'/research-product/ExpenseToCostBatch', params, true);
}




